<template>
  <div>
    <h2 class="ts-text-gray-500 ts-text-base ts-capitalize">
      <i class="fas fa-book-reader ts-mr-3"></i> {{ $t('serviceRequest.info') }}
    </h2>
    <table class="ts-w-full">
      <tbody>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceRequestDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.service_request_date
                ? resource.service_request_date
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceRequestType') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.service_request_type
                ? resource.service_request_type.service_request_type
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceStatus') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            <div class="ts-flex ts-items-center">
              <a-icon
                type="tag"
                theme="filled"
                :style="
                  'color:' + resource
                    ? serviceStatus[resource.service_status].color
                    : 'black' + ';'
                "
              />
              <p class="ts-mb-0">
                {{
                  resource.service_status_name
                    ? resource.service_status_name
                    : ''
                }}
              </p>
            </div>
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.feeType') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.fee_type ? resource.fee_type.product_name_en : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.requestedBy') }} /
            {{ $t('serviceRequest.customer') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.customer ? resource.customer.customer_name : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.contact') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.contact_number ? resource.contact_number : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceVillage') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.village_name ? resource.village_name : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceCommune') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.commune_name ? resource.commune_name : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceDistrict') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.district_name ? resource.district_name : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serviceProvince') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.province_name ? resource.province_name : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.invoice') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.invoice ? resource.invoice.invoice_no : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.product') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.product ? resource.product.product_name_en : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.serialNo') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.product_serial ? resource.product_serial.serial_no : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.requiredSparePart') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            <span
              class="badge bg-success tw-capitalize px-2"
              v-if="resource.required_spare_part"
              >Yes
            </span>
            <span class="badge bg-danger tw-capitalize px-2" v-else>No </span>
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.technician1') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.technician1_by
                ? resource.technician1_by.employee_name_en
                : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.technician2') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.technician2_by
                ? resource.technician2_by.employee_name_en
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.orderKads') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.order_kads ? resource.order_kads : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.plateNumber') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.plate_number ? resource.plate_number : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.openDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.open_date ? resource.open_date : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.closeDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.close_date ? resource.close_date : '-' }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.owner') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.owner_by ? resource.owner_by.employee_name_en : '-' }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.informant') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.informant_by
                ? resource.informant_by.employee_name_en
                : '-'
            }}
          </td>
        </tr>
        <tr class="ts-border-b ts-border-t">
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.createdBy') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{
              resource.created_by ? resource.created_by.employee_name_en : '-'
            }}
          </td>
          <td
            class="ts-mt-12 ts-px-3 ts-font-semibold ts-text-right ts-py-1 ts-bg-gray-200 ts-w-1/5"
          >
            {{ $t('serviceRequest.createdDate') }}
          </td>
          <td class="ts-px-3 ts-w-3/12">
            {{ resource.created_date ? resource.created_date : '-' }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { method } from 'lodash'

export default {
  props: ['resource'],
  data() {
    return {
      showModal: false,
      loading: false
    }
  },
  computed: {
    serviceStatus() {
      return [
        {
          label: 'Pending',
          value: 0,
          color: '#6c757d'
        },
        {
          label: 'Progressing',
          value: 1,
          color: '#17a2b8'
        },
        {
          label: 'Completed',
          value: 2,
          color: '#28a745'
        },
        {
          label: 'Cancel',
          value: 3,
          color: '#dc3545'
        }
      ]
    }
  },
  methods: {
    onChangeServiceStatus(record) {
      record._deleting = true
      this.$store
        .dispatch('serviceManagement/serviceRequest/changeServiceStatus', {
          id: record.service_request_id,
          data: { service_status: record.service_status }
        })
        .then(response => {
          this.$toasted.success(response.message)
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.fetchData()
        })
        .finally(() => (record._deleting = false))
    }
  }
}
</script>
<style>
.anticon {
  line-height: -1;
}
</style>
